export default "__VITE_ASSET__QY1wq8LF__"